import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="/politicas/politica-privacidad-web.pdf" target="_blank" rel="noopener noreferrer">
          Política de privacidad (web)
        </a>
        <a href="/politicas/politica-privacidad-redes.pdf" target="_blank" rel="noopener noreferrer">
          Política de privacidad (redes sociales)
        </a>
        <a href="/politicas/aviso-legal.pdf" target="_blank" rel="noopener noreferrer">
          Aviso legal
        </a>
        <a href="/politicas/politica-cookies.pdf" target="_blank" rel="noopener noreferrer">
          Política de cookies
        </a>
      </div>

      <p>© {new Date().getFullYear()} CUALO Innovation Consulting SL. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;

